<template>
  <div class="playVideo-content">
    <div
      class="video-back"
      @click="back(-1)">
      <img src="../assets/images/nav/back1.png" />
    </div>
    <div
      ref="playVideo"
      class="playVideo-video">
      <div
        v-if="ggBool && isShowAd && playimg"
        class="video-ggao-box">
        <a
          :href="playimg.url"
          target="_blank">
          <base-image
            class="video-ggao-box-img"
            encrypt
            :ratio="750 / 426"
            :url="playimg.imgbase64.url"
            :type="playimg.imgbase64.type" />
        </a>
        <div
          class="video-ggao-clear"
          @click="clearFun()">{{ closeTitle }}</div>
      </div>
      <video
        ref="videoPlayer"
        class="video-js vjs-default-skin vjs-big-play-centered"
        playsinline="true"
        webkit-playsinline="true"></video>
      <div
        v-if="!isDestroy"
        ref="xbb">
        <component
          :is="xbbComponent"
          :player="player"
          :is-destory.sync="isDestroy"
          :playing-event.sync="playingEvent"
          :pause-event.sync="pauseEvent" />
      </div>
    </div>

    <div class="playVideo-container">
      <div class="playVideo-info">
        <div class="playVideo-info-title">{{ videoinfo.title }}</div>
        <div class="playVideo-info-desc">
          <div class="playVideo-info-desc-update">{{ videoinfo.updated_at }}</div>
          <div class="playVideo-info-desc-views">{{ (videoinfo.pageviews / 10000).toFixed(2) }}万次播放</div>
        </div>
      </div>
      <div class="playVideo-toolbar">
        <a
          v-show="isShowAd"
          :href="activity"
          target="_blank"
          class="playVideo-toolbar-redEnvelope">
          <img
            v-for="number of 4"
            :key="number"
            src="../assets/images/home/hb_icon.png"
            alt="红包"
            class="playVideo-toolbar-redEnvelope-icon">
        </a>
        <div class="playVideo-toolbar-function">
          <button
            class="playVideo-toolbar-function-btn"
            @click="feedbackDialog(true)">
            <img
              src="../assets/images/feedback_icon.png"
              alt="反馈"
              class="playVideo-toolbar-function-icon">
            <div class="playVideo-toolbar-function-text">反馈</div>
          </button>
          <button
            class="playVideo-toolbar-function-btn"
            @click="$snackbar({ msg: `功能开发中、敬请期待` })">
            <img
              src="../assets/images/favor_icon.png"
              alt="收藏"
              class="playVideo-toolbar-function-icon">
            <div class="playVideo-toolbar-function-text">收藏</div>
          </button>
        </div>
      </div>
      <div
        v-if="isShowAd && conterimg"
        class="playVideo-centerAd">
        <a
          :href="conterimg.url"
          target="_blank">
          <base-image
            class="playVideo-centerAd-img"
            :ratio="690 / 180"
            encrypt
            :url="conterimg.imgbase64.url"
            :type="conterimg.imgbase64.type" />
        </a>
      </div>
      <div class="playVideo-tags">
        <button
          v-for="item in videoinfo.labls"
          :key="item.id"
          class="playVideo-tags-tag"
          @click="clickTagHandler({ title: item.name, id: item.id })">
          {{ item.name }}
        </button>
      </div>
      <video-may-like
        :show-more="showMayLikeMore"
        :data="mayLikeList"
        @click-tag="clickTagHandler"
        @click-more="clickMayLikeMoreButton" />
    </div>

    <video-tag-list
      v-show="tagVideo.visible"
      :style="tagVideoStyle"
      :title="tagVideo.title"
      :data="tagVideo.list"
      @close="tagVideo.visible = false"
      @click-tag="clickTagHandler" />

    <!-- 签到领彩金 -->
    <a
      v-show="isShowAd"
      :href="checkin"
      target="_blank">
      <img
        class="playVideo-checkin-img"
        src="../assets/images/home/qdimg.png" />
    </a>
    <feedback
      v-if="showFeedback"
      :videoId="+videoId"
      @close-dialog="feedbackDialog(false)"></feedback>
  </div>
</template>
<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import { checkinUrl, activityUrl } from '@/API/mine'
import { imgToBase64 } from '../API/common'
import baseImage from '@/components/baseImage'
import VideoMayLike from '@/components/VideoMayLike'
import VideoTagList from '@/components/VideoTagList'
import feedback from '@/components/feedback.vue'
import {
  selectVideoInfo,
  getLikeList,
  playggimg,
  conterggimg,
  getVideoTopic
} from '@/API/playVideo'
import Xbb from '@/views/xbb/Index'
import Fake from '@/views/xbb/Fake'
import OnlyAd from '@/views/xbb/OnlyAd'
import Guest from '@/views/xbb/Guest'
import 'videojs-overlay'
import 'videojs-seek-buttons'
import 'videojs-seek-buttons/dist/videojs-seek-buttons.css'
import { mapMutations, mapState } from 'vuex'
import { thirdMode } from '@/utils/index.js'

export default {
  name: 'playVideo',
  components: {
    Xbb,
    Fake,
    baseImage,
    VideoMayLike,
    VideoTagList,
    feedback,
    OnlyAd,
    Guest
  },
  data () {
    return {
      //  flag:false,
      comment: [],
      videoinfo: {},
      videoId: '',
      ad: {},
      tagsHeight: 0,
      playimg: null,
      conterimg: null,
      ggBool: false,
      timeNum: 5,
      closeTitle: '',
      checkin: '',
      activity: '',
      progress: 0,
      pause: true,
      progressPause: false,
      showGoldWarp: false,
      goldWarpType: 'WAIT',
      goldWarpLastTime: new Date().getTime() + 5000,
      isseeking: false,
      setTimeoutOnpause: null,
      messionActionType: null,
      messionDescription: null,
      // 是否关闭广告我的变量
      Description: false, // 弹窗句子
      CloseAd: false,
      countOne: 0,
      player: null,
      isMounted: false,
      thirdMode,

      // 猜你喜欢
      mayLikeList: [],
      mayLikeQuery: {
        page: 1
      },
      showMayLikeMore: false,
      showFeedback: false,

      // 标签影片
      tagVideo: {
        visible: false,
        title: '',
        list: []
      },
      isDestroy: false
    }
  },
  computed: {
    ...mapState(['isShowAd', 'Judgment', 'xbbBonus']),
    /**
     * activity - 活動 , ad - 廣告, thirdMode - 第三方, isGuest - 是否爲訪客, loginVideoSwitch - 訪客可否看影片開關
     *
     * thirdMode = true --> 外接版
     * isGuest = true, loginVideoSwitch = true --> 訪客, 開啟訪客無法看影片 -> Guest
     * activity = true , ad = true  --> 有活動, 有廣告 -> component = Xbb
     * activity = true , ad = false --> 有活動, 無廣告 -> component = Xbb
     * activity = false, ad = true  --> 無活動, 有廣告 -> component = OnlyAd
     * activity = false, ad = false --> 無活動, 無廣告 -> component = null
     *
     * thirdMode = false --> 自營版 -> component = Fake
     */
    xbbComponent () {
      const { ad, activity, isGuest, loginVideoSwitch } = this.xbbBonus
      if (!thirdMode) return 'Fake'
      if (isGuest && loginVideoSwitch) return 'Guest'

      let component = null
      if (activity) component = 'Xbb'
      if (!activity && ad) component = 'OnlyAd'
      return component
    },
    playerSource () {
      return {
        src: this.videoinfo.videopath || '',
        type: 'application/vnd.apple.mpegurl'
      }
    },
    tagVideoStyle () {
      const style = {}
      if (!this.isMounted) return style
      if (this.$store.getters.device === 'phone') {
        style.top = this.$refs.playVideo && this.$refs.playVideo.clientHeight + 'px'
      } else {
        style.top = document.body.offsetHeight / 2 + 'px'
      }
      return style
    }
  },
  async created () {
    this.ggBool = true
    this.closeTitle = this.timeNum + 'S'
    this.videoId = this.$route.query.id
    sessionStorage.setItem('videoId', this.videoId)
    // 拿参数
    if (!this.$store.getters.isShowAd) {
      this.CloseAd = true
    }
    this.getVideoInfo(() => {
      this.setTimeFun()
    })
    this.getPlayggImg()
    this.getconterggimg()
    this.getcheckinUrl()
    this.getActivityUrl()
    await this.getMayLikeList(this.mayLikeQuery)
  },
  mounted () {
    this.init()
    this.isMounted = true
  },
  methods: {
    ...mapMutations(['setJudgment']),
    init () {
      this.player = videojs(this.$refs.videoPlayer, {
        // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        // 自动播放属性,muted:静音播放
        autoplay: false,
        // 建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: 'auto',
        // 视频比例
        aspectRatio: '16:9',
        // 流体模式
        fluid: true,
        // //填充
        fill: true,
        // //响应式
        responsive: false,
        language: 'zh-CN',
        // 是否循环播放
        loop: true,
        // 播放前图片
        // poster: this.videoData.image,
        // 是否预加载
        // preload: "auto",
        // 阻止播放器为具有data-setup属性的媒体元素运行自动设置
        autoSetup: false,
        // 播放速度
        playbackRates: [1, 1.5, 2],
        controlBar: {
          volumePanel: {
            inline: false
          },
          pictureInPictureToggle: false
        },
        html5: {
          hls: {
            cacheEncryptionKeys: true,
            overrideNative: !videojs.browser.IS_SAFARI
          }
        }
      })

      this.player.addChild('Overlay', {
        start: 'ready',
        content: this.$refs.xbb
      })
      this.player.seekButtons({
        forward: 10,
        back: 10,
        forwardIndex: 10,
        backIndex: 10
      })

      // 註冊播放事件
      this.player.on('playing', (e) => {
        this.playingEvent(e)
      })
      // 註冊暫停事件
      this.player.on('pause', (e) => {
        if (!this.player.seeking()) {
          this.pauseEvent(e)
        }
      })
    },
    playingEvent () { },
    pauseEvent () { },
    getVideoInfo (callback) {
      selectVideoInfo()
        .then((res) => {
          this.videoinfo = res.rescont
          callback()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getPlayggImg () {
      playggimg()
        .then((res) => {
          this.playimg = res.rescont[0]
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getconterggimg () {
      conterggimg()
        .then((res) => {
          this.conterimg = res.rescont[0]
        })
        .catch((err) => {
          console.log(err)
        })
    },
    clearFun () {
      if (this.timeNum <= 0) {
        if (this.shouldNavigateAdLink()) {
          this.handleNavigateAdLink()
        }
        this.ggBool = false
      } else {
        this.ggBool = true
      }
    },
    shouldNavigateAdLink () {
      try {
        const key = `SG-H5:adTracking:player:${this.playimg.url}`
        const storedTimestamp = localStorage.getItem(key)
        if (!storedTimestamp) {
          return true
        }
        const now = Date.now()
        const oneDayMs = 24 * 60 * 60 * 1000
        return now - parseInt(storedTimestamp, 10) >= oneDayMs
      } catch (e) {
        console.warn('localStorage not available, defaulting to allow navigation:', e)
        return false
      }
    },
    handleNavigateAdLink () {
      if (this.playimg.url) {
        try {
          const key = `SG-H5:adTracking:player:${this.playimg.url}`
          const timestamp = Date.now()
          localStorage.setItem(key, timestamp.toString())
        } catch (e) {
          console.warn('localStorage not available:', e)
        }
        window.open(this.playimg.url, '_blank')
      }
    },
    getcheckinUrl () {
      checkinUrl()
        .then((res) => {
          this.checkin = res.rescont.url
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getActivityUrl () {
      activityUrl()
        .then((res) => {
          this.activity = res.rescont.url
        })
        .catch((err) => {
          console.log(err)
        })
    },
    setTimeFun () {
      const _this = this
      if (_this.CloseAd) {
        setTimeout(() => {
          _this.player.src(_this.playerSource)
          _this.player.load(_this.url)
        }, 1000)
      } else {
        const i = setInterval(function () {
          if (_this.timeNum > 0) {
            _this.timeNum--
            _this.closeTitle = _this.timeNum + 'S'
          } else {
            _this.player.src(_this.playerSource)
            _this.player.load(_this.url)
            _this.closeTitle = '关闭'
            window.clearInterval(i)
          }
        }, 1000)
      }
      imgToBase64(this.videoinfo.coverbase64.url, this.videoinfo.coverbase64.type).then(data => {
        this.player.poster(data)
      })
    },
    liChange (id) {
      this.$router.replace({
        path: '/playLink',
        query: {
          id
        }
      })
    },
    back () {
      this.$router.go(-1)
    },
    async getTagVideoList (id) {
      try {
        const res = await getVideoTopic(id)
        return res.rescont.data
      } catch (err) {
        console.log(err)
        return []
      }
    },
    async clickTagHandler ({ title, id }) {
      const list = await this.getTagVideoList(id)
      this.tagVideo = {
        visible: true,
        title,
        list
      }
    },
    async getMayLikeList (query) {
      try {
        const res = await getLikeList(query)
        this.mayLikeList = [...this.mayLikeList, ...res.rescont.data]
        this.showMayLikeMore = res.rescont.next_page_url !== null
      } catch (err) {
        console.log(err)
      }
    },
    async clickMayLikeMoreButton () {
      this.mayLikeQuery.page++
      await this.getMayLikeList(this.mayLikeQuery)
    },
    feedbackDialog (status) {
      this.showFeedback = status
    }
  }
}
</script>
<style scoped>
.van-icon {
  font-size: 20px !important;
  color: #fff !important;
}

.video-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.6);
}

.video-back {
  position: absolute;
  top: 2px;
  left: 5px;
  z-index: 999;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  padding: 10px 10px;
}

.video-back img {
  width: 10px;
  height: 20px;
  object-fit: cover;
}

.video-ggao-box {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
}

.video-ggao-box-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 是否 关闭广告计时器样式 */
.video-ggao-clear {
  position: absolute;
  top: 10px;
  right: 15px;
  width: 50px;
  height: 26px;
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 13px;
}

.playVideo-content {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.playVideo-video {
  position: relative;
  width: 100%;
}

.playVideo-container {
  box-sizing: border-box;
  width: 100%;
  padding: 15px;
  overflow-y: auto;
  background-color: #1c1c1c;
}

.playVideo-info {
  color: rgba(255, 255, 255, 1);
  text-align: left;
}

.playVideo-info-title {
  display: -webkit-box;
  overflow: hidden;
  font-size: 15px;
  font-weight: 400;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.playVideo-info-desc {
  display: flex;
}

.playVideo-info-desc-update {
  margin-right: 5px;
  font-size: 12px;
  line-height: 16px;
}

.playVideo-info-desc-views {
  font-size: 12px;
  line-height: 16px;
}

.playVideo-toolbar {
  display: flex;
  align-items: center;
  width: 100%;
  padding-bottom: 10px;
  margin: 10px 0;
  border-bottom: 1px solid #333;
}

.playVideo-toolbar-redEnvelope {
  display: flex;
  align-items: center;
}

.playVideo-toolbar-redEnvelope-icon {
  width: 18px;
  height: 24px;
}

.playVideo-toolbar-redEnvelope-icon + .playVideo-toolbar-redEnvelope-icon {
  margin-left: 4px;
}

.playVideo-toolbar-function {
  display: flex;
  margin-left: auto;
}

.playVideo-toolbar-function-btn {
  display: flex;
  padding: 0 3px;
  cursor: pointer;
  background-color: transparent;
  border: none;
}

.playVideo-toolbar-function-btn + .playVideo-toolbar-function-btn {
  margin-left: 5px;
}

.playVideo-toolbar-function-icon {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}

.playVideo-toolbar-function-text {
  margin-left: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #b2b2b2;
}

.playVideo-centerAd {
  position: relative;
  width: 100%;
  margin-bottom: 15px;
  border-radius: 6px;
}

.playVideo-centerAd-img {
  width: 100%;
  overflow: hidden;
  font-size: 0;
  border-radius: 6px;
}

.playVideo-tags {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 10px;
}

.playVideo-tags-tag {
  box-sizing: border-box;
  padding: 5px 10px;
  margin: 0 7px 10px 0;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
  background: rgba(255, 92, 56, 1);
  border: none;
  border-radius: 20px;
}

.playVideo-dec-list-title {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-left: 8px;
  font-size: 15px;
  font-weight: 500;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
}

.playVideo-dec-list-title::after {
  position: absolute;
  top: 50%;
  left: 0;
  width: 3px;
  height: 40%;
  content: "";
  background: rgba(255, 92, 56, 1);
  transform: translateY(-50%);
}

.content-gditem-box {
  width: 100%;
  height: 40px;
}

.content-gditem {
  width: 80px;
  height: 40px;
  margin: 0 auto;
  font-size: 15px;
  font-weight: 400;
  line-height: 40px;
  color: rgba(255, 92, 56, 1);
}

/* 我的样式 */
.Pop-ups-father-box {
  position: relative;
  display: flex;
  width: 70%;
  max-width: 70%;
  padding: 10px;
  margin: 50% auto 0;
  background-color: rgb(255, 255, 255);
  border: 1px solid red;
  border: 6px solid #ecc374;
  border-radius: 11px;
}

.Pop-ups-img {
  position: fixed;
  width: 40%;
  height: 15%;
  margin-top: -20%;
  margin-left: 17%;
}

.Pop-ups-box {
  width: 100%;
  height: 100%;
}

.Pop-ups-h3 {
  padding-top: 7%;
  margin-top: 4%;
  font-size: 17px;
  color: #bf8646;
  text-align: center;
}

.Pop-ups-h3-one {
  padding-top: 16%;
  margin-top: 4%;
  font-size: 17px;
  color: #bf8646;
  text-align: center;
}

.Pop-ups-h3-tow {
  margin-top: -4%;
  font-size: 15px;
  color: #bf8646;
  text-align: center;
}

.pop-ups-font-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
  margin-top: -5%;
}

.Pop-ups-p {
  align-items: center;
  margin-left: 14%;
  font-size: 14px;
  font-weight: bold;
  color: #87766e;
}

.Pop-ups-p-tow {
  align-items: center;
  margin-left: 7%;
  font-size: 14px;
  font-weight: bold;
  color: #87766e;
}

.Pop-ups-i {
  margin-left: 1%;
  font-size: 27px;
  font-style: normal;
  font-weight: bold;
  color: #db9746;
}

.Pop-ups-img-box {
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  margin-top: 10px;
}

.Pop-ups-img-box-one {
  width: 50px;
  height: 100%;
  margin-left: 8%;
  background: #f9f5ea;
}

.Pop-ups-img-box-tow {
  width: 50px;
  height: 100%;
  margin-left: 10%;
  background: #f9f5ea;
}

.Pop-ups-img-box-one-img {
  height: 30px;
  margin: -10% auto;
}

.Pop-ups-img-box-tow-img {
  height: 30px;
  margin: -10% auto;
}

.Pop-ups-img-box-one-i {
  width: 100%;
  height: 20px;
  margin-top: 12px;
  font-size: 15px;
  font-style: normal !important;
  font-weight: bold;
  line-height: 20px !important;
  line-height: 25px;
  color: #d9a74e;
  text-align: center;
  background: #f1d78d;
}

.Pop-ups-img-box-one-i > i {
  font-style: normal !important;
}

.Pop-ups-img-box-tow-i > i {
  font-style: normal !important;
}

.Pop-ups-img-box-tow-i {
  width: 100%;
  height: 20px;
  margin-top: 12px;
  font-size: 15px;
  font-weight: bold;
  line-height: 20px !important;
  line-height: 25px;
  color: #d9a74e;
  text-align: center;
  background: #f1d78d;
}

.Pop-ups-img-box-one-span {
  position: absolute;
  display: flex;
  width: 37px;
  height: 37px;
  margin-top: -20%;
  margin-left: 3%;
  line-height: 40px;
  color: white;
  background-color: #aca076;
  border-radius: 50px;
  transform: rotate(20deg);
}

.Pop-ups-img-box-tow-span {
  position: absolute;
  display: flex;
  width: 37px;
  height: 37px;
  margin-top: -50px;
  margin-left: 3%;
  line-height: 40px;
  color: white;
  background-color: #aca076;
  border-radius: 50px;
  transform: rotate(20deg);
}

.Pop-ups-button {
  align-items: center;
  width: 90%;
  height: 30px;
  margin-top: 13%;
  font-size: 15px;
  font-weight: bold;
  line-height: 24px;
  color: rgb(255, 255, 255);
  background: linear-gradient(270deg, rgb(189, 157, 125), rgb(249, 221, 189));
  border: none;
  border-radius: 16px;
}

.gold {
  position: fixed;
  display: flex;
  width: 20px;
  height: 20px;
}

.icon-img-box {
  position: absolute;
  top: 8px;
  right: 8px;
  bottom: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-img-one {
  width: 25px;
  height: 25px;
}

.icon-img-tow {
  width: 25px;
  height: 25px;
}

.Pop-ups-father-box-tow {
  position: relative;
  display: flex;
  width: 70%;
  max-width: 70%;
  padding: 10px;
  margin: 50% auto 0;
  background-color: rgb(255, 255, 255);
  border: 1px solid red;
  border: 6px solid #ecc374;
  border-radius: 11px;
}

.Pop-ups-button-box-tow {
  display: flex;
  margin: 15% 0 3%;
}

.Pop-ups-button-one {
  align-items: center;
  width: 45%;
  height: 30px;
  margin: 0 5px;
  font-size: 15px;
  line-height: 24px;
  color: rgb(255, 255, 255);
  background: linear-gradient(270deg, rgb(189, 157, 125), rgb(249, 221, 189));
  border: none;
  border-radius: 16px;
}

.Pop-ups-button-tow {
  align-items: center;
  width: 45%;
  height: 30px;
  margin: 0 0 0 5px;
  font-size: 15px;
  line-height: 24px;
  color: rgb(255, 255, 255);
  background: linear-gradient(270deg, rgb(189, 157, 125), rgb(249, 221, 189));
  border: none;
  border-radius: 16px;
}

.zero {
  position: absolute;
  display: block;
  overflow: hidden;
  font-size: 14px;
  color: #fff07b;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.playVideo-checkin-img {
  position: fixed;
  right: 15px;
  bottom: 65px;
  z-index: 999;
  height: 36px;
}

@media screen and (max-width: 769px) {
  .playVideo-video {
    height: 56vw;
  }

  .playVideo-container {
    position: absolute;
    top: 56vw;
    bottom: 0;
    left: 0;
  }
}

@media screen and (min-width: 768px) {
  .playVideo-content {
    overflow: auto;
  }
}

@media screen and (min-width: 1025px) {
  .playVideo-checkin-img {
    right: calc(50% - 512px + 15px);
  }
}

/*
* 快進按鈕數字處理
*/

.video-js.vjs-v7 >>> .vjs-seek-button.skip-forward .vjs-icon-placeholder::before {
  transform: scale(-1, 1) rotate(-45deg) scale(1.5);
}

.video-js.vjs-v7 >>> .vjs-seek-button.skip-forward .vjs-icon-placeholder::after {
  display: block;
  font-weight: 500;
  content: '10';
  transform: scale(0.7) translateX(-3px);
}

/*
* 快退按鈕數字處理
*/

.video-js.vjs-v7 >>> .vjs-seek-button.skip-back .vjs-icon-placeholder::before {
  transform: rotate(-45deg) scale(1.5);
}

.video-js.vjs-v7 >>> .vjs-seek-button.skip-back .vjs-icon-placeholder::after {
  display: block;
  font-weight: 500;
  content: '10';
  transform: scale(0.7) translateX(3px);
}

/*
* 配合加上快進快退按鈕後, 進度條太短的問題
*/

.video-js >>> .vjs-progress-control {
  width: 6em;
}

.video-js >>> .vjs-control,
.video-js >>> .vjs-volume-panel.vjs-volume-panel-vertical {
  width: 2.8em;
}

.video-js >>> .vjs-remaining-time {
  width: 6em;
}

.vjs-playback-rate >>> .vjs-menu-button,
.vjs-playback-rate >>> .vjs-playback-rate-value,
.video-js >>> .vjs-remaining-time {
  padding: 0;
}

.video-js >>> .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-vertical,
.video-js >>> .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical,
.video-js >>> .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical,
.video-js >>> .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical,
.video-js >>> .vjs-volume-panel.vjs-hover .vjs-mute-control ~ .vjs-volume-control.vjs-volume-vertical,
.video-js >>> .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical {
  left: -3em;
}
</style>



// WEBPACK FOOTER //
// src/components/playVideo.vue